var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasEditedItems && !_vm.hasUneditedItems
        ? _c(
            "div",
            { staticClass: "item-edit pl-0" },
            [
              _c("p", [
                _vm._v("Folgende Erfahrungen hast du bereits eingetragen:")
              ]),
              _vm._v(" "),
              _c("SelectedItems", {
                attrs: {
                  "characteristic-type": _vm.characteristicType,
                  "characteristic-items": _vm.characteristicItems,
                  selected: _vm.editedItems,
                  deletable: "",
                  "with-edit-button": "",
                  "label-type": _vm.labelType,
                  flat: ""
                },
                on: {
                  deleteItem: function($event) {
                    _vm.itemToDelete = $event
                  },
                  editItem: function($event) {
                    return _vm.editItem($event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasUneditedItems
        ? [
            _vm._t("questionFurtherItems"),
            _vm._v(" "),
            _vm.additionConfig.inline
              ? [
                  _vm.subTitle
                    ? _c("h3", { staticClass: "my-4" }, [
                        _vm._v(_vm._s(_vm.subTitle))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.relevantItems, function(item) {
                    return _c(
                      "div",
                      { key: item.item.id, staticClass: "mb-3" },
                      [
                        _c(
                          "h2",
                          [
                            _c("Label", {
                              attrs: {
                                characteristic: item.item,
                                "label-type": _vm.labelType
                              }
                            }),
                            _vm._v(" "),
                            _vm.getSupplements(item)
                              ? [
                                  _vm._v(
                                    "(" + _vm._s(_vm.getSupplements(item)) + ")"
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("AdditionEdit", {
                          staticClass: "pl-5",
                          attrs: {
                            item: item,
                            "experience-config": _vm.additionConfig.experience,
                            "self-assessment-config":
                              _vm.additionConfig.selfAssessment,
                            "application-desire": _vm.isDesire(item),
                            type: _vm.type
                          },
                          on: {
                            change: function($event) {
                              return _vm.onAdditionChange(item, $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  })
                ]
              : [
                  _c("SelectedItems", {
                    attrs: {
                      "characteristic-type": _vm.characteristicType,
                      "characteristic-items": _vm.characteristicItems,
                      selected: _vm.uneditedItems,
                      "label-type": _vm.labelType,
                      deletable: "",
                      flat: ""
                    },
                    on: {
                      deleteItem: function($event) {
                        _vm.itemToDelete = $event
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c("Button", {
                        attrs: {
                          text: _vm.buttonText,
                          secondary: "",
                          smaller: ""
                        },
                        on: { click: _vm.openAdditionsMatrixFan }
                      })
                    ],
                    1
                  )
                ]
          ]
        : _c("div", { staticClass: "mt-4" }, [
            _c(
              "div",
              { staticClass: "messages correct-inner-left-padding" },
              _vm._l(_vm.computedMessages, function(message, j) {
                return _c(
                  "div",
                  {
                    key: "forced-message--" + j,
                    staticClass: "message",
                    style: { "animation-delay": j + "s" }
                  },
                  [_c("span", { domProps: { innerHTML: _vm._s(message) } })]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item-edit",
                style: { "animation-delay": _vm.computedMessages.length + "s" }
              },
              [
                _c("RadioGroup", {
                  attrs: { options: _vm.furtherOptions, stacked: "" },
                  on: { change: _vm.furtherChanged },
                  model: {
                    value: _vm.further,
                    callback: function($$v) {
                      _vm.further = $$v
                    },
                    expression: "further"
                  }
                })
              ],
              1
            )
          ]),
      _vm._v(" "),
      _vm.itemToDelete
        ? _c(
            "ConfirmPopUp",
            {
              attrs: { title: _vm.deleteConfirmTitle },
              on: {
                confirm: _vm.deleteItem,
                hidden: function($event) {
                  _vm.itemToDelete = undefined
                }
              }
            },
            [_vm._t("deleteConfirmText", null, { item: _vm.itemToDelete })],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }